import React, { Component } from 'react'

import AppPortal from 'components/UI/AppPortal'
import Notification from 'components/UI/Notification'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next'

class DistributionErrorNotification extends Component {
    constructor(props) {
        super(props)
        this.state = {
            hide: false,
        }
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.dates !== this.dates) {
            this.setState({ hide: false })
        }
    }
    handleClose() {
        this.setState({ hide: true })
    }
    render() {
        const { show, dates, t } = this.props
        if (!show || this.state.hide || !dates) return null
        return (
            <AppPortal>
                <Notification
                    title={t('notificationsDistributionErrorTitle')}
                    onClose={() => this.handleClose()}
                >
                    <p>{t('notificationsDistributionErrorNotification')}</p>
                </Notification>
            </AppPortal>
        )
    }
}

DistributionErrorNotification.propTypes = {
    show: PropTypes.bool,
    dates: PropTypes.array,
    dispatch: PropTypes.func,
    t: PropTypes.func,
}

const mapStateToProps = ({ distribution }) => {
    return { show: distribution.error, dates: distribution.dates }
}

export default connect(mapStateToProps)(withTranslation()(DistributionErrorNotification))
